<!--<div *ngIf="list">-->
    <!--<app-dashboards [parent]="{ groups: {'servings' : groupList} }"  ></app-dashboards>-->
<!--</div>-->
<div>
    <app-dashboards [parent]="{}"  ></app-dashboards>
</div>
<app-loader *ngIf="loading"></app-loader>
